import React from 'react'
import {SendEmailDialog} from './SendEmailDialog'
import {SendFaxDialog} from './SendFaxDialog'
import {withToggles} from 'startlibs/lib/hocs'
import {Button, Dialog} from 'startlibs/lib/components'

@withToggles('emailDialog', 'faxDialog', 'faxJustSent', 'keyImagesDialog', 'emailJustSent', 'pdfDiscontinuedDialog')
export class PDFButtons extends React.Component {

  openJustSent = () => {
    this.props.emailJustSent.open()
    this.props.emailJustSent.closeAfter(1000)()
  }

  openFaxJustSent = () => {
    this.props.faxJustSent.open()
    this.props.faxJustSent.closeAfter(1000)()
  }

  render() {
    const {
      isUploadingKeyImages, sharedReportView, shareDialogMessage, attachedReport, sharingOptions,isPHIPossible,
      fax, sendFaxFetcher, faxDialog, faxJustSent, reportInfoCard,
      emailJustSent, emailDialog, keyImagesDialog, pdfDiscontinuedDialog, userEmail, UploadingKeyImagesDialog, sendEmailFetcher, reportRecipients, hideSavePdfButton
    } = this.props
    return (
      <div className="buttons-container">
        {
          !sharedReportView &&
          <a
            onClick={isUploadingKeyImages ? keyImagesDialog.toggle : emailDialog.toggle}
            className="button small-button with-icon"
          >
            <span className="icon icon-email"/>E-mail
          </a>
        }
        {
          fax && fax.enabled && !sharedReportView &&
          <a
            onClick={isUploadingKeyImages ? keyImagesDialog.toggle : faxDialog.toggle}
            className="button small-button with-icon"
          >
            <span className="icon icon-fax"/>Fax
          </a>
        }
        {
          faxDialog.isOpen &&
          <SendFaxDialog
            fax={fax}
            sendEmailFetcher={sendFaxFetcher}
            closeDialog={faxDialog.close}
            confirmSent={this.openFaxJustSent}
          />
        }
        <a
          onClick={pdfDiscontinuedDialog.open}
          className="button small-button with-icon"
        >
          <span className="icon icon-download"/>Save PDF
        </a>
        {
          pdfDiscontinuedDialog.isOpen &&
          <Dialog closeDialog={pdfDiscontinuedDialog.close} title="Individual PDF reports unavailable">
            <Dialog.Content>
              <p>Downloading or printing individual reports as PDF is no longer available. To get a copy of your reports, please download the report archive instead.</p>
            </Dialog.Content>
            <Dialog.Footer>
              <Button highlight onClick={pdfDiscontinuedDialog.close}>OK</Button>
            </Dialog.Footer>
          </Dialog>
        }
        {
          !hideSavePdfButton &&
          <a
            onClick={pdfDiscontinuedDialog.open}
            className="button small-button with-icon highlight"
          >
            <span className="icon icon-print"/>Print
          </a>
        }
        {
          emailDialog.isOpen &&
          <SendEmailDialog
            reportRecipients={reportRecipients}
            sendEmailFetcher={sendEmailFetcher}
            userEmail={userEmail}
            shareDialogMessage={shareDialogMessage}
            attachedReport={attachedReport}
            isPHIPossible={isPHIPossible}
            sharingOptions={sharingOptions}
            reportInfoCard={reportInfoCard}
            closeDialog={emailDialog.close}
            confirmSent={this.openJustSent}
          />
        }
        {
          emailJustSent.isOpen &&
          <div className="system-notification success "><span>Report successfully sent via e-mail.</span> <a
            className="icon icon-x" onClick={emailJustSent.close}/></div>
        }
        {
          faxJustSent.isOpen &&
          <div className="system-notification success "><span>Report successfully sent via e-mail.</span> <a
            className="icon icon-x" onClick={emailJustSent.close}/></div>
        }
        {
          keyImagesDialog.isOpen &&
          <UploadingKeyImagesDialog closeDialog={keyImagesDialog.close}/>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/report-components/src/modules/viewer/PdfButtons.jsx